import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._m(0)])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nuts_pay",
      "label-for": "nuts_pay",
      "label": "Tef Pay"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.nuts_pay == true
    },
    on: {
      "change": _vm.setNutsPay
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "usar_smart_tef",
      "label-for": "usar_smart_tef",
      "label": "Smart-TEF"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.form.usar_smart_tef === true
    },
    on: {
      "change": _vm.setSmartTef
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20",
      "state": _vm.validateState('descricao'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "serial_pos",
      "label-for": "serial_pos",
      "label": "Serial Pos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20",
      "state": _vm.validateState('serial_pos'),
      "autofocus": ""
    },
    model: {
      value: _vm.$v.form.serial_pos.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.serial_pos, "$model", $$v);
      },
      expression: "$v.form.serial_pos.$model"
    }
  })], 1)], 1)], 1)], 1), !_vm.form.nuts_pay && !_vm.form.usar_smart_tef ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "username",
      "label-for": "username",
      "label": "Usuário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.form.username,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "username", $$v);
      },
      expression: "form.username"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), !_vm.form.nuts_pay && !_vm.form.usar_smart_tef ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "password",
      "label-for": "password",
      "label": "Senha Integração"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "password",
      "maxlength": "100",
      "autofocus": ""
    },
    model: {
      value: _vm.form.password,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "password", $$v);
      },
      expression: "form.password"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.usar_smart_tef ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Authorization Bearer",
      "label-for": "smart_tef_token"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "smart_tef_token",
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": _vm.form.smart_tef_configurado ? 'Já configurado' : ''
    },
    model: {
      value: _vm.form.smart_tef_token,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "smart_tef_token", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.smart_tef_token"
    }
  })], 1)], 1) : _vm._e(), _vm.form.usar_smart_tef ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Token",
      "label-for": "smart_tef_gateway_token"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "smart_tef_gateway_token",
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": _vm.form.smart_tef_configurado ? 'Já configurado' : ''
    },
    model: {
      value: _vm.form.smart_tef_gateway_token,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "smart_tef_gateway_token", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.smart_tef_gateway_token"
    }
  })], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Modelos",
      "label-for": "modelos"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.modelo,
      expression: "form.modelo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "modelos",
      "id": "modelos"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.modelos, function (m, index) {
    return _c('option', {
      key: 'modelos' + index,
      domProps: {
        "value": m.id
      }
    }, [_vm._v(" " + _vm._s(m.descricao) + " ")]);
  }), 0)])], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "ativo",
      "label-for": "ativo",
      "label": "Ativo"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": true,
      "checked": _vm.form.status == true
    },
    on: {
      "change": _vm.setAtivo
    }
  }), _c('span')])])])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_novo_terminal",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'posLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    }
  }, [_vm._v(" Cadastro ")])]);
}];
export { render, staticRenderFns };